export default __webpack_public_path__ + "static/media/Resume-Cole-Public.a7a22856.pdf";